module.exports = __webpack_public_path__ + "img/woman.ae8c9931.png";